/* "Barrel" of Http Interceptors */
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {ZahlungInterceptor} from './zahlung-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [{provide: HTTP_INTERCEPTORS, useClass: ZahlungInterceptor, multi: true}];
